module.exports = __webpack_public_path__ + "static/media/008-circle-white.e8e431ea.svg";